module.exports = __webpack_public_path__ + "static/media/bay_islands_psychology_logo.9b58dc46.png";